<template>
  <div class="weather-widget p-2">
    <b-row class="row" data-fittext="">
      <b-col>
        <h2 class="text-center" title="Temperature"><i :class="'wi ' + ('wi-metno-' + ld.get(appdata.response, 'weather.0.icon', 'wi-na'))"></i></h2>
        <h4 class="text-center">{{ ld.get(appdata.response, 'weather.0.temperature', 'n/a') }}°{{ ld.get(appdata.response, 'weather.0.units.temperature', 'km/h') }}</h4>
      </b-col>
      <b-col>
        <h2 class="text-center" title="Cloud Cover"><i class="wi wi-cloudy"></i></h2>
        <h4 class="text-center">{{ ld.get(appdata.response, 'weather.0.cloud', 'n/a') }}%</h4>
      </b-col>
      <b-col>
        <h2 class="text-center" title="Rainfall"><i class="wi wi-rain-mix"></i></h2>
        <h4 class="text-center">{{ ld.get(appdata.response, 'weather.0.rain', 'n/a') }}{{ ld.get(appdata.response, 'weather.0.units.rain', 'mm') }}</h4>
      </b-col>
      <b-col>
        <h2 class="text-center" title="Fog"><i class="wi wi-fog"></i></h2>
        <h4 class="text-center">{{ ld.get(appdata.response, 'weather.0.fog', 'n/a') }}%</h4>
      </b-col>
      <b-col>
        <h2 class="text-center" title="Wind"><i :class="'wi wi-wind wi-towards-' + ld.get(appdata.response, 'weather.0.wind.direction_text', 'N').toLowerCase()"></i></h2>
        <h4 class="text-center">{{ ld.get(appdata.response, 'weather.0.wind.speed', 'n/a') }}{{ ld.get(appdata.response, 'weather.0.units.wind', 'km/h') }}</h4>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import 'weather-icons/sass/weather-icons.scss'
import 'weather-icons/sass/weather-icons-wind.scss'

import { get } from 'lodash'

export default {

  name: 'Weather',
  props: ["appdata", "options"],

  methods: {

  },

  data() {
    return {
      opts: {},
      ld: {
        get: _.get
      },
    }
  }
}
</script>
